export default function (buttons) {
	return this.html.element({tag: 'ul', classes: ['dialog__buttons'], content:
		this.loop(buttons, (button) => this.html.element({tag: 'li', classes: ['dialog__buttonItem'], content:
			this.render('button', button)
		}))
	});
}
